import React from 'react'
import { useSelector } from 'react-redux'

import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Badge
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { Help as HelpIcon, Update as UpdateIcon } from '@material-ui/icons'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import AssignmentReturnIcon from '@material-ui/icons/AssignmentReturn'
import Feedback from '@material-ui/icons/Feedback'

import {
  toggleSideHelp,
  RootStoreModel,
  getCustomerDomain,
  getCustomerDomainClientArea,
  toggleSideChangelogAction,
  toggleSideChangelog
} from '../../../../redux'

export const HeaderMenu: React.FC = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const isMenuOpen = Boolean(anchorEl)

  const { t } = useTranslation('translation')

  const handleProfileMenuOpen = React.useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [anchorEl]
  )

  const handleSideHelpToggle = React.useCallback((event: React.MouseEvent<HTMLElement>) => {
    toggleSideHelp()
  }, [])

  const handleSideChangelogToggle = React.useCallback((event: React.MouseEvent<HTMLElement>) => {
    toggleSideChangelog()
  }, [])

  const handleMenuClose = React.useCallback(() => {
    setAnchorEl(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anchorEl])

  const profile = useSelector((state: RootStoreModel) => state.profile && state.profile)
  const newRelease = useSelector((state: RootStoreModel) => state.layout.newReleaseNotification)
  const customerDomain = getCustomerDomain() || ''
  const customerDomainClientArea = getCustomerDomainClientArea() || ''

  const menuId = React.useMemo(() => 'primary-search-account-menu', [])

  const backToClassicTooltip = t('header.actions.backToClassicTooltip')
  const changelogTooltip = t('header.actions.changelogTooltip')
  const helpTooltip = t('header.actions.helpTooltip')
  const accountTooltip = t('header.actions.accountTooltip')
  const supportPortal = t('header.actions.supportPortal')

  const renderMenu = React.useMemo(
    () => (
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        id={menuId}
        keepMounted
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        <MenuItem disabled>
          <p>{profile.user?.name}</p>
        </MenuItem>
        <MenuItem onClick={profile.logoutHandler}>
          <ListItemIcon>
            <ExitToAppIcon />
          </ListItemIcon>
          <ListItemText>{t('header.actions.logout')}</ListItemText>
        </MenuItem>
      </Menu>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [handleMenuClose, profile]
  )

  return (
    <div>
      <Tooltip title={supportPortal}>
        <a
          href={
            customerDomainClientArea.startsWith('https')
              ? customerDomainClientArea
              : `https://${customerDomainClientArea}`
          }
          target="_blank"
          rel="noreferrer"
        >
          <IconButton aria-label={supportPortal}>
            <Feedback />
          </IconButton>
        </a>
      </Tooltip>
      {/* <Tooltip title={backToClassicTooltip}>
        <a
          href={customerDomain.startsWith('https') ? customerDomain : `https://${customerDomain}`}
          target="_blank"
          rel="noreferrer"
        >
          <IconButton aria-label={backToClassicTooltip}>
            <AssignmentReturnIcon />
          </IconButton>
        </a>
      </Tooltip> */}
      <Tooltip title={changelogTooltip}>
        <IconButton aria-label={changelogTooltip} onClick={handleSideChangelogToggle}>
          <Badge color="primary" variant="dot" invisible={!newRelease}>
            <UpdateIcon />
          </Badge>
        </IconButton>
      </Tooltip>
      {/* <Tooltip title="Notificaciones">
        <IconButton aria-label={helpTooltip} onClick={() => { javascript: void (0) }}>
          <Badge color="secondary" badgeContent={8}>
            <NotificationIcon />
          </Badge>
        </IconButton>
      </Tooltip> */}
      <Tooltip title={helpTooltip}>
        <IconButton aria-label={helpTooltip} onClick={handleSideHelpToggle}>
          <HelpIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={accountTooltip}>
        <IconButton
          edge="end"
          aria-label={accountTooltip}
          aria-controls={menuId}
          aria-haspopup="true"
          onClick={handleProfileMenuOpen}
        >
          <AccountCircleIcon />
        </IconButton>
      </Tooltip>
      {renderMenu}
    </div>
  )
}

export default React.memo(HeaderMenu)
